import type { FC } from 'react'
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import NotificationPage from '@/pages/NotificationPage'
import SearchPage from '@/pages/SearchPage'
import UserPage from '@/pages/UserPage/UserPage'

import ExecutivesLayout from '../../layouts/ExecutivesLayout'
import ChatPage from '../../pages/ChatPage'
import { Settings } from '../../pages/Dispatcher/Settings'
import ExecutivesCustomerFeedbackPage from '../../pages/Executives/ExecutivesCustomerFeedbackPage'
import ExecutivesDashboardPage from '../../pages/Executives/ExecutivesDashboardPage'
import ExecutivesPerformanceReportsPage from '../../pages/Executives/ExecutivesPerformanceReportsPage'
import ExecutivesRevenueAnalysisPage from '../../pages/Executives/ExecutivesRevenueAnalysisPage/ExecutivesRevenueAnalysisPage'
import ExecutivesTechnicianPerformancePage from '../../pages/Executives/ExecutivesTechnicianPerformancePage'
import ExecutivesWorkOrderKpisPage from '../../pages/Executives/ExecutivesWorkOrderKpisPage'
import { UserRoleEnum } from '../../types'

import ProtectedRoute from './ProtectedRoute'
import { EnumExecutiveRoutes, EnumGlobalRoutes } from './routerConstants'

const ExecutivesRoutes: FC = () => (
    <ProtectedRoute allowedRoles={[UserRoleEnum.EXECUTIVES]}>
        <Routes>
            <Route element={<ExecutivesLayout />}>
                <Route index element={<ExecutivesDashboardPage />} />{' '}
                <Route
                    path={EnumExecutiveRoutes.EXECUTIVES_PERFORMANCE_REPORTS}
                    element={<ExecutivesPerformanceReportsPage />}
                />
                <Route
                    path={EnumExecutiveRoutes.EXECUTIVES_REVENUE_ANALYSIS}
                    element={<ExecutivesRevenueAnalysisPage />}
                />
                <Route
                    path={EnumExecutiveRoutes.EXECUTIVES_KPI}
                    element={<ExecutivesWorkOrderKpisPage />}
                />
                <Route
                    path={EnumExecutiveRoutes.EXECUTIVES_TECHNICIAN_PERFORMANCE}
                    element={<ExecutivesTechnicianPerformancePage />}
                />
                <Route
                    path={EnumExecutiveRoutes.EXECUTIVES_CUSTOMER_FEEDBACK}
                    element={<ExecutivesCustomerFeedbackPage />}
                />
                <Route path={EnumGlobalRoutes.CHAT} element={<ChatPage />} />
                <Route
                    path={EnumGlobalRoutes.CHAT + '/:id'}
                    element={<ChatPage />}
                />
                <Route path={EnumGlobalRoutes.CHAT} element={<ChatPage />} />
                <Route
                    path={EnumGlobalRoutes.USER_PAGE + ':id'}
                    element={<UserPage />}
                />
                <Route
                    path={EnumGlobalRoutes.SEARCH}
                    element={<SearchPage />}
                />
                <Route
                    path={EnumGlobalRoutes.NOTIFICATIONS}
                    element={<NotificationPage />}
                />
                <Route
                    path={EnumGlobalRoutes.SETTINGS}
                    element={<Settings />}
                />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
        </Routes>
    </ProtectedRoute>
)

export default ExecutivesRoutes
